import { createFileRoute, redirect } from '@tanstack/react-router'
import { REDIRECT } from '@/lib/auth-redirect'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: REDIRECT.postLogin })
  },
})
